export const blockIconsImageEuro = (
	<span className='material-symbols-outlined'>euro</span>
);
